import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
    APP_INITIALIZER,
    EnvironmentProviders,
    makeEnvironmentProviders,
    Provider,
} from '@angular/core';
import { authInterceptor } from './auth.interceptor';
import { LoginService } from '../login.service';

export function initAuthService(loginService: LoginService) {
    return () => loginService.initializeAuth();
}


export const provideAuth = (): Array<Provider | EnvironmentProviders> => [
    makeEnvironmentProviders([
        provideHttpClient(withInterceptors([authInterceptor]))
    ]),
    {
        provide: APP_INITIALIZER,
        useFactory: initAuthService,
        deps: [LoginService],
        multi: true
    }
];

